import type { AppliedBy } from "@unbox/api";

export type RuleSignalAction = "added" | "blocked" | "approved" | "rejected";

const ACTION_VERBS: Record<RuleSignalAction, string> = {
  added: "Added",
  blocked: "Blocked",
  approved: "Approved",
  rejected: "Rejected",
};

export const ruleSignalCopy = (action: RuleSignalAction, appliedBy: AppliedBy): string => {
  const verb = ACTION_VERBS[action];
  if (appliedBy.source === "rule") return `Auto-${verb.toLowerCase()} by`;
  return `${verb} manually`;
};
